/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import './EmiTile.css';
import { Grid } from '@mui/material';
import { fonts, themes } from '../../themes/themes';
import { DateField } from '../../../components';
import { baseDateFormatting } from '../../helper';

interface contentTileType {
  tile_key: any;
  tile_value: any;
  tile_date?: string;
  value_color?: string;
  key_color?: string;
  is_bold?: boolean;
}

const EmiTile: React.FC<contentTileType> = ({
  tile_key,
  tile_value,
  tile_date,
  value_color = themes.tileValue_black,
  key_color = themes.tileValue_black,
  is_bold = false,
}) => {
  return (
    <Grid container className="emi-container">
      <Grid
        item
        xs={6}
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: key_color,
          textTransform: 'capitalize',
          fontWeight: 'bold',
        }}
      >
        {tile_key}
      </Grid>
      <Grid
        item
        xs={6}
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: value_color,
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'flex-end',
          textTransform: 'capitalize',
          fontWeight: is_bold ? 'bold' : 'normal',
        }}
      >
        {tile_value}
      </Grid>
      <Grid
        item
        xs={6}
        style={{
          fontSize: '10px',
          fontFamily: fonts.fontFamily,
          fontStyle: 'italic',
          color: themes.tileValue_black,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          textTransform: 'capitalize',
          paddingBottom: '10px',
          paddingTop: '5px',
        }}
      >
        {tile_date ? (
          <DateField value={tile_date} format={baseDateFormatting} />
        ) : null}
      </Grid>
    </Grid>
  );
};

export default EmiTile;
